import { ActionIcon, type ActionIconProps } from '@any-ui-react/core';
import classNames from 'classnames';
import type { MouseEventHandler } from 'react';
import { MaterialIcons, type MaterialIconsProps } from '@/common/components/shared/material-icons';

interface Props
  extends Pick<ActionIconProps, 'className' | 'disabled' | 'size' | 'variant'>,
    Pick<MaterialIconsProps, 'fill' | 'fontSize'> {
  iconClassName?: string;
  iconName: string;
  /** The name of the button. Without it the name is the icon's own text (its ligature name), which no one reads aloud well. */
  'aria-label'?: string;
  onClick: MouseEventHandler<HTMLButtonElement>;
}

export const PlainActionMaterialIcon = ({
  'aria-label': ariaLabel,
  className,
  disabled,
  fill,
  fontSize,
  iconClassName,
  iconName,
  size,
  variant,
  onClick,
}: Props) => (
  <ActionIcon
    aria-label={ariaLabel}
    className={className}
    disabled={disabled}
    size={size}
    tabIndex={-1}
    variant={variant}
    onClick={onClick}
  >
    <MaterialIcons
      fill={fill}
      fontSize={fontSize}
      iconName={iconName}
      className={classNames({ 'cursor-pointer': !disabled }, iconClassName)}
    />
  </ActionIcon>
);
